//@mui
import { Stack } from '@mui/system';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//components
import { Box, Button, Typography, useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { invalidFields } from 'components/FormCreator/types';
import { FormCard } from 'theme/elements/Forms';
//constants
import { balanceTransStepsPrefix, digitalBalanceAddStepsPrefix } from 'constants/balance.constants';
import { getAltshulerAccounts, getExistingBankAccounts } from 'state/reducers/bank-account.reducers';
import { getCompanyBankAccount, getSuggestedAccountId } from 'state/reducers/balance.reducers';
import _ from 'lodash';
import { FormButton } from 'theme/elements/Buttons';
import { LoadingButton } from '@mui/lab';

interface TransferDetailsFormProps {
	invalidFields: invalidFields;
	handleBankListPick: any;
	handleMobile: () => void;
	handleContinueOnComputer: () => void;
	handleBack: () => void;
	handleCancel: any;
	loading: boolean;
	isContinueDisabled: boolean;
	isMobile: any;
}

export default function TransferDetailsForm(props: TransferDetailsFormProps) {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const altshulerAccounts = useAppSelector(getAltshulerAccounts);
	const suggestedAccountId = useAppSelector(getSuggestedAccountId);
	const existBankAccounts = useAppSelector(getExistingBankAccounts);
	const companyBankAccountId = useAppSelector(getCompanyBankAccount);

	const suggestedAccount = useMemo(() => {
		const selectedAccount = existBankAccounts.find((account: any) => account.id === companyBankAccountId);
		let suggested = altshulerAccounts.find((account: any) => account.bankId === _.get(selectedAccount, 'bankId'));
		if (!suggested) {
			suggested = altshulerAccounts.find((account: any) => account.id === suggestedAccountId);
		}
		return suggested;
	}, [altshulerAccounts, suggestedAccountId, existBankAccounts, companyBankAccountId]);

	const [selectedAccountId, setSelectedAccountId] = useState<number | null>(_.get(suggestedAccount, 'id'));

	const otherAccounts = useMemo(() => {
		return altshulerAccounts.filter((account) => account.id !== _.get(suggestedAccount, 'id'));
	}, [suggestedAccount]);

	const handleBankAccountPick = (id: number) => {
		if (altshulerAccounts.find((account) => account.id === id)) {
			setSelectedAccountId(id);
			props.handleBankListPick(id);
		}
	};

	useEffect(() => {
		props.handleBankListPick(_.get(suggestedAccount, 'id'));
	}, [suggestedAccount]);

	return (
		<Box component="form" noValidate sx={{ marginTop: '32px' }}>
			<FormCard>
				<Stack spacing={2} sx={{ marginBottom: 1 }}>
					<Typography variant="h4" sx={{ textAlign: 'start', fontWeight: 'bold' }}>
						{t(`${digitalBalanceAddStepsPrefix}.3.section_title`)}
					</Typography>

					<Stack spacing={0.5}>
						<Typography
							variant="body4"
							sx={{
								textAlign: 'start',
								color: theme.palette.root.textGreen,
								fontWeight: 'normal',
								lineHeight: '20px',
								unicodeBidi: 'plaintext',
							}}
						>
							{t(`${digitalBalanceAddStepsPrefix}.3.subtitle1`)}
						</Typography>

						<Typography
							variant="body4"
							sx={{
								textAlign: 'start',
								color: theme.palette.root.textGreen,
								fontWeight: 'normal',
								lineHeight: '20px',
								unicodeBidi: 'plaintext',
							}}
						>
							{t(`${digitalBalanceAddStepsPrefix}.3.subtitle2`)}
						</Typography>

						<Typography
							variant="body4"
							sx={{
								textAlign: 'start',
								color: theme.palette.root.textGreen,
								fontWeight: 'bold',
								lineHeight: '20px',
								unicodeBidi: 'plaintext',
							}}
						>
							{t(`${digitalBalanceAddStepsPrefix}.3.subtitle3`)}
						</Typography>
					</Stack>

					<Stack direction="row" spacing={3} sx={{ marginTop: 4 }}>
						{/* <FormButton sx={{ flex: 1 }}>
							<Button
								variant="contained"
								fullWidth
								onClick={props.handleMobile}
								sx={{
									backgroundColor: theme.palette.primary.main,
									'&:hover': {
										backgroundColor: theme.palette.primary.dark,
									},
									padding: '12px 24px',
								}}
							>
								{t(`${digitalBalanceAddStepsPrefix}.3.mobile_button.text`)}
							</Button>
						</FormButton> */}

						{/* {!props.isMobile && ( */}
							<FormButton sx={{ flex: 1 }}>
								<LoadingButton
									variant="contained"
									fullWidth
									disabled={props.isContinueDisabled}
									onClick={props.handleContinueOnComputer}
									loading={props.loading}
									sx={{
										backgroundColor: theme.palette.primary.main,
										'&:hover': {
											backgroundColor: theme.palette.primary.dark,
										},
										padding: '12px 24px',
									}}
								>
									{t(`${digitalBalanceAddStepsPrefix}.3.continue_computer_button.text`)}
								</LoadingButton>
							</FormButton>
						{/* )} */}

						<FormButton sx={{ flex: 1 }}>
							<Button fullWidth onClick={props.handleBack} disabled={props.loading}>
								{t(`${digitalBalanceAddStepsPrefix}.3.back_button.text`)}
							</Button>
						</FormButton>
					</Stack>
				</Stack>
			</FormCard>
		</Box>
	);
}
